import {
  ConversationData,
  ConversationStatusGroup,
  getConversationStatusMap,
  getWorkspaceId,
  useAppSelector,
  useLazyGetConversationStatusesQuery,
  useUpdateStatusMutation,
  showToast,
  dispatch,
  ErrorVariants,
} from '@zonofi/zono-money-store';
import { useEffect, useCallback, useMemo } from 'react';
import { SVGS } from '../../assets';

interface UpdateStatusPayload {
  updateConversations: (item: ConversationData) => void;
}

const StatusImageMap: Record<ConversationStatusGroup, string> = {
  [ConversationStatusGroup.OPEN]: SVGS.NewConversation,
  [ConversationStatusGroup.INPROGRESS]: SVGS.InProgressConversation,
  [ConversationStatusGroup.CLOSED]: SVGS.ClosedConversation,
};

export const useUpdateStatus = ({
  updateConversations,
}: UpdateStatusPayload) => {
  const workspaceId = useAppSelector(getWorkspaceId);
  const statusMap = useAppSelector(getConversationStatusMap);
  const [updateStatus, updateStatusResponse] = useUpdateStatusMutation();

  const onUpdateStatus = ({
    status,
    conversationId,
  }: {
    status: string;
    conversationId: string;
  }) => {
    updateStatus({
      conversationId,
      sellerWorkspaceId: workspaceId,
      status,
    })
      .unwrap()
      .then(() => {
        dispatch(
          showToast({
            canDisplay: true,
            message: 'Status updated successfully!',
            responseStatus: 'success',
            type: ErrorVariants.SUCCESS,
          })
        );
      })
      .catch((error) => {
        dispatch(
          showToast({
            canDisplay: true,
            message: 'Failed to update status!',
            responseStatus: 'Error',
            type: ErrorVariants.DANGER,
          })
        );
      });
  };

  useEffect(() => {
    if (updateStatusResponse.isSuccess && updateStatusResponse.data?.data) {
      updateConversations(updateStatusResponse.data?.data);
    }
  }, [updateStatusResponse]);

  const statusData = useMemo(() => {
    return Object.entries(statusMap).flatMap(([category, statusList]) => {
      return statusList.map((status) => ({
        title: status,
        image: StatusImageMap[category as ConversationStatusGroup],
      }));
    });
  }, [statusMap]);

  return { statusData, onUpdateStatus };
};
